import { Modal } from "@shopify/polaris"
import { useEffect } from "react"

import APIDashboard from "@/api/dashboard"
import SuccessfullyIcon from "@/assets/svg/SuccessfullyIcon"
import DiyRate from "@/components/DiyRate/DiyRate"
import stores from "@/stores"

import Confetti from "./confetti"
import styles from "./index.module.scss"

type PraiseGuideModalProps = {
  open: boolean
  title: string
  onClose: () => void
}
const PraiseGuideModal = (props: PraiseGuideModalProps) => {
  const { open, title, onClose } = props
  const { ReturnRequestsDataStore, UserInfoStore } = stores

  useEffect(() => {
    if (open) {
      // 纸屑动画

      const timer = setInterval(() => {
        Confetti({})
      }, 400)

      setTimeout(() => {
        clearInterval(timer)
      }, 1200)
    }
  }, [open])

  const handleRateChange = (e: number) => {
    onClose()
    if (e <= 4) {
      ReturnRequestsDataStore.setShowBadFeedBackModal(true)
    } else {
      APIDashboard.closePraiseGuide()
      UserInfoStore.setSingleData("is_close_praise_guide", true)
    }
  }

  const linkUrl =
    "https://apps.shopify.com/parcel-panel-returns-exchanges?locale=zh-CN#modal-show=WriteReviewModal&st_campaign=rate-app&st_source=admin&utm_campaign=installed&utm_source=follow"

  return (
    <Modal
      noScroll
      open={open}
      title={title}
      // @ts-ignore
      onClose={() => {
        // if (e.target.nodeName === "svg" || e.target.className === "Polaris-Button__Icon"){
        //   onClose()
        //   APIDashboard.closePraiseGuide()
        //   UserInfoStore.setSingleData("is_close_praise_guide", true)
        // }
        // 允许点背景关闭
        onClose()
        APIDashboard.closePraiseGuide()
        UserInfoStore.setSingleData("is_close_praise_guide", true)
      }}
    >
      <Modal.Section>
        <div className={styles.container}>
          <div className={styles.mainHeader}>
            <SuccessfullyIcon />
            <div className={styles.title}>
              <div>{t("SubmittedSuccessfully")}</div>
              <div>{t("MoreRevolutionaryFeaturesComingSoon")}</div>
            </div>
          </div>
          <div className={styles.mainBody}>
            <img
              src="https://return-cdn.parcelpanel.net/public/logo.png"
              width={48}
              height={48}
              alt=""
            />
            <div className={"mt-4"}>
              {t("WouldYouMindLeavingUsAReview")} <br />
              {t("ThisWillMotivateUsToContinueToImp")}{" "}
            </div>

            <DiyRate url={linkUrl} onSelected={handleRateChange} />
          </div>
        </div>
      </Modal.Section>
    </Modal>
  )
}

export { PraiseGuideModal }
